import React from "react";

const SvgArrowDown = props => <svg width="1em" height="1em" viewBox="0 0 8 7" fill="currentColor" {...props}><path d="M4.866 6.5a1 1 0 01-1.732 0L.536 2A1 1 0 011.402.5h5.196A1 1 0 017.464 2L4.866 6.5z" fill="#DCE0E9" /></svg>;

export default SvgArrowDown;